import React, { useState } from "react";
import PropTypes from "prop-types";

function ExpandableList({
  items,
  limit,
  ListRenderer,
  BtnRenderer,
  limitAllowance,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isExpandable = items.length > limitAllowance + limit;
  const visibleItems = items.slice(0, isExpanded ? items.length : limit);

  return (
    <>
      <ListRenderer items={isExpandable ? visibleItems : items} />

      {isExpandable ? (
        <BtnRenderer
          toggle={() => setIsExpanded(!isExpanded)}
          hiddenItemCount={items.length - limit}
          isExpanded={isExpanded}
        />
      ) : null}
    </>
  );
}

ExpandableList.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  limit: PropTypes.number.isRequired,
  ListRenderer: PropTypes.func.isRequired,
  BtnRenderer: PropTypes.func.isRequired,
  limitAllowance: PropTypes.number,
};

ExpandableList.defaultProps = {
  limitAllowance: 2,
};

export default ExpandableList;
